import './style.scss'

import { useStore } from '@nanostores/react'
import clsx from 'clsx'
import { atom } from 'nanostores'
import { useEffect, useRef } from 'react'

import css from './Notification.module.css'

interface Notification {
	status: 'error' | 'none'
	text: string
}

const INITIAL: Notification = {
	status: 'none',
	text: ''
}

export const $notification = atom<Notification>(INITIAL)

export const reset = () => $notification.set(INITIAL)

const watchStatus = (popover: HTMLElement) =>
	$notification.listen(notification => {
		const isClosed = notification.status === 'none'
		isClosed ? popover.hidePopover() : popover.showPopover()
	})

export function Notification() {
	const { status, text } = useStore($notification)
	const ref = useRef<HTMLDivElement | null>(null)

	useEffect(() => {
		const popover = ref.current

		if (popover) {
			return watchStatus(popover)
		}
	}, [])

	return (
		<div
			className={clsx(css.notification, css[status])}
			// @ts-ignore Recheck in React 19
			popover='manual'
			ref={ref}
		>
			{text}
		</div>
	)
}
